<body>
   
    <div class="main-wrapper">
    <div class="main-content">
            <header>
           
                    <div class="head-line">
                 
                        <p>Dash Board</p>
                    </div>
                <div class="user-wrapper">
                   <p>Skillplex Technologies</p>
                  
                    <div>
                        <img class="log1" src="../../assets/images/Ellipse 2.png">
                    </div>
                </div>
            </header>
            
            <main class="main-2">

               <div class="container">
                <div class="projects">
                    
                    
                    <div class="two-screen">
<!---sec sidebar-->

<div class="second-side">
    <p class="table-heading">Agency list</p>
    <div class="search-m">
                   
        <input type="text" id="searchQueryInput1" placeholder="Search" value=""   [(ngModel)]="searchQuery">
        <button type="submit" id="searchQuerySubmit"><svg viewBox="0 0 24 24" style="width: 24px; height: 24px;">
        <path fill="#666666" d="M9.5,3A6.5,6.5 0 0,1 16,9.5C16,11.11 15.41,12.59 14.44,13.73L14.71,14H15.5L20.5,19L19,20.5L14,15.5V14.71L13.73,14.44C12.59,15.41 11.11,16 9.5,16A6.5,6.5 0 0,1 3,9.5A6.5,6.5 0 0,1 9.5,3M9.5,5C7,5 5,7 5,9.5C5,12 7,14 9.5,14C12,14 14,12 14,9.5C14,7 12,5 9.5,5Z"></path>
        </svg>
        </button>
   
</div>
<div class="side-content">
<!-- <div class="main-box alternate-color">
<div class="second-list">
<div class="v-img"><img src="../../assets/images/user1.jpeg"></div>
<div><h6 class="name-one">CHANDRA mohan</h6>
    <p class="name-two">Address:<span> Kakkanad, Ernakulam</span></p>
    <p class="name-two">Owner:<span>Allexander</span></p>
       
    </div>
    </div>
    <img src="../../assets/images/right-arrow.png">
</div> -->
<div *ngFor="let agency of agencyDetails  | filter:searchQuery" >
    <div 
      [ngClass]="{'main-box': isSelected(agency._id), 'main-box2': !isSelected(agency._id), 'alternate-color': true}"
      (click)="selectAgency(agency._id)">
      <div 
        [ngClass]="{'second-list': isSelected(agency._id), 'second-list2': !isSelected(agency._id)}">
        <div class="v-img">
          <img [src]="agency.logo" alt="{{agency.agencyName}}">
        </div>
        <div>
          <h6 class="name-one">{{ agency.agencyName }}</h6>
          <p class="name-two">Address:<span> {{ agency.address }}</span></p>
          <p class="name-two">Owner:<span>{{ agency.owner }}</span></p>
        </div>
      </div>
    </div>
  </div>
  
    </div>



    <div class="footer-section1" (click)="addAgencyFlag=true;agencyDetailsFlag=false">
        <button><img src="../../assets/images/plus-blue.svg" >Add New Agency</button>
      
     </div>
     <div class="footer-section2">

        <img src="../../assets/images/accruon-footer.png">
     </div>
    
    </div>



<!---------------->
                    <div class="card2" *ngIf="agencyDetailsFlag">
                        <p class="table-heading">Agency Details</p>       
                           
                            <div class="agency-head"  [attr.style]="'background-image: url(' + (selectedAgencyDetails.coverImage ? selectedAgencyDetails.coverImage : '../../assets/images/pic1.jpg') + '); background-size: cover;'">

                            <img src="{{selectedAgencyDetails.logo}}">
                            <p>{{selectedAgencyDetails.agencyName}}</p>
                        </div>

                        <table class="agency-table">
                            <tr>
                                <td>
                                    <p class="name-two">Address</p>
                                    <p class="name-one">{{selectedAgencyDetails.address}}</p>

                                </td>
                            </tr>
                            <!-- <tr>
                                <td>
                                <p class="name-two">Products</p>
                                    <p class="name-one">{{selectedAgencyDetails.product}}</p>
                             </tr> -->
                          
                        <tr>
                                <td class="pdf-td"  >
                                    <div class="second-div">
                                        <div class="v-img" >
                                            <img   src="{{selectedAgencyDetails.contractUpload}}"  *ngIf="isImage(selectedAgencyDetails.contractUpload)">
                                            <img src="../../assets/images/pdf.png"  *ngIf="isPDF(selectedAgencyDetails.contractUpload)">
                                        </div>
                                        <div><h6 class="name-one">{{ selectedAgencyDetails.contractUpload.substring(selectedAgencyDetails.contractUpload.lastIndexOf('/') + 1)}}</h6>
                                            <p class="name-two">Size: 128 KB</p>
                                           
                                            </div>
                                            </div>
                                 <div><button class="white-btn" (click)="image=selectedAgencyDetails.contractUpload;popUp=true" >View</button></div>
                                </td>
                            </tr>
                            <!-- </tr> -->
                        <tr>
                                <td>
                                    <div class="content">
                                        <button class="add-n" (click)="disableAgency()">Disable Agency</button>
                                        <!---->
                                        <button class="btn-two" (click)="editAgency()">Edit details</button>
                                    </div>   
                                </td>
                            </tr>
                            <!-- </tr> -->
                        </table>
                        <p class="table-heading">Owner Details</p> 
                        
                       
                        <div class="agency-head"  [attr.style]="'background-image: url(' + (selectedAgencyDetails.ownerCoverImage ? selectedAgencyDetails.ownerCoverImage : '../../assets/images/pic1.jpg') + '); background-size: cover;'">
                            <img src="{{selectedAgencyDetails.ownerImage}}">
                            <p>{{selectedAgencyDetails.owner}}</p>
                        </div>
                        
                        <table class="agency-table">
                            <tr>
                                <td>
                                    <p class="name-two">Email ID</p>
                                    <p class="name-one">{{selectedAgencyDetails.email}}</p>

                                </td>
                            </tr>
                            <tr>
                                <td>
                                <p class="name-two">Contact number</p>
                                    <p class="name-one">{{selectedAgencyDetails.contactNumber}}</p>
                                    </tr>
                          
                         
                        </table>

                    

                        <p class="table-heading">Staff List</p> 
                        <table class="staffList-table"  >
                            <tr (click)="selectedStaff(staff)" *ngFor="let staff of staffDetails"  >
                                <td >
                                    <div class="second-list2">
                                        <div class="v-img"><img src="{{staff.photo}}"></div>
                                        <div><p class="name-one">{{staff.name}}</p>
                                            <span><img src="../../assets/images/call.svg" class="call-img">{{staff.phoneNumber}}</span>
                                           
                                            </div>
                                            </div>
                                </td>
                            </tr>
                           

                        </table>  

                        <div class="content">
                          
                            <button class="btn-two" (click)="agencyDetailsFlag=false;addStaffFlag=true;editStaffFlag=false;this.staffForm.reset();">Add new user</button>
                        </div>   

                        </div>



<!-- details ends-->
 <!--  staff start -->
 <div class="card2" *ngIf="addStaffFlag">
    <p class="table-heading">Agency Details</p>       
    <div class="agency-head"  [attr.style]="'background-image: url(' + (selectedAgencyDetails.coverImage ? selectedAgencyDetails.coverImage : '../../assets/images/pic1.jpg') + '); background-size: cover;'">
        <img src="{{selectedAgencyDetails.logo}}" >
        <p>{{selectedAgencyDetails.agencyName}}</p>
    </div>

  
    <p class="table-heading">Staff Details</p>       
    <div class="agency-head" id="agency-h1"  [attr.style]="'background-image: url(' + (staffForm.value.coverImage ? staffForm.value.coverImage : '../../assets/images/pic1.jpg') + '); background-size: cover;'">
     
     
        <!-- <img src="../../assets/images/user-no.jpg">
      
       <img src="../../assets/images/plus-black.png" class="plus-b"> -->

       <input type="file" id="fileInput" class="file-input" (change)="upload('staffLogo',$event)">
       <label for="fileInput" class="file-label">
        <img alt="User Image"  [src]="staffForm.value.photo ? staffForm.value.photo : '../../assets/images/user-no.jpg'">
           <img src="../../assets/images/plus-black.png" class="plus-b"></label>


        <div>
   
     
    <div class="edit-icon" >
        <input type="file" id="fileInput2" class="file-input2" (change)="upload('staffCoverLogo',$event)">
        <label for="fileInput2" class="file-label">
        <img src="../../assets/images/edit.png"></label>
    </div>

  





    </div>
    </div>
    
  

    <form class="staff-form" [formGroup]="staffForm">
        <div class="row">
            <div class="col-lg-6 col-xs-12 col-sm-6">
        <div class="form-group">
          <label>Name*</label>
          <input type="text" class="form-control" placeholder="Type here" formControlName="name">
        </div>
        </div>
        <div class="col-lg-6 col-xs-12 col-sm-6">
            <div class="form-group">
              <label>Phone*</label>
              <input type="text" class="form-control" placeholder="Type here"  formControlName="phoneNumber">
            </div>
            </div>
   

    <div class="col-lg-6 col-xs-12 col-sm-6 ext-padding">
    <div class="col-lg-12 col-xs-12 col-sm-6">
        <div class="form-group">
          <label>Whatsapp*</label>
          <input type="text" class="form-control" placeholder="Type here" formControlName="whatsAppNumber">
        </div>
        </div>
        <div class="col-lg-12 col-xs-12 col-sm-6">
            <div class="form-group">
              <label>Email Id*</label>
              <input type="text" class="form-control" placeholder="Type here" formControlName="email">
            </div>
            </div>
            </div>
            <div class="col-lg-6 col-xs-12 col-sm-6">
                <div class="form-group">
                  <label>Address*</label>
                  <textarea class="form-control" placeholder="Type here" style="    height: 99px;" formControlName="address"></textarea>
                  <!-- <input type="text" class="form-control" placeholder="Type here"> -->
                </div>
                </div>


                <div class="col-lg-6 col-xs-12 col-sm-6">
                    <div class="form-group">
                      <label>User name*</label>
                      <input type="text" class="form-control" placeholder="Type here" formControlName="userName">
                    </div>
                    </div>
                    <div class="col-lg-6 col-xs-12 col-sm-6">
                        <div class="form-group">
                          <label>Password*</label>
                          <input type="password" class="form-control" placeholder="Type here" formControlName="password">
                        </div>
                        </div>
            </div>
      </form>



    <div class="content">
        <button class="add-n" (click)="addStaffFlag=false;agencyDetailsFlag=true">Back</button>
        <!---->
        <button class="btn-two" (click)="staffCrud('Add')">Create Staff</button>
    </div>

    </div>







    <div class="card2" *ngIf="editStaffFlag">
        <p class="table-heading">Agency Details</p>       
        <div class="agency-head"  [attr.style]="'background-image: url(' + (selectedAgencyDetails.coverImage ? selectedAgencyDetails.coverImage : '../../assets/images/pic1.jpg') + '); background-size: cover;'">
            <img src="{{selectedAgencyDetails.logo}}" >
            <p>{{selectedAgencyDetails.agencyName}}</p>
        </div>
    
      
        <p class="table-heading">Staff Details</p>       
        <div class="agency-head" id="agency-h1"  [attr.style]="'background-image: url(' + (staffForm.value.coverImage ? staffForm.value.coverImage : '../../assets/images/pic1.jpg') + '); background-size: cover;'" >
         
         
            <!-- <img src="../../assets/images/user-no.jpg">
          
           <img src="../../assets/images/plus-black.png" class="plus-b"> -->
    
           <input type="file" id="fileInput" class="file-input" (change)="upload('staffLogo',$event)">
           <label for="fileInput" class="file-label">
            <img alt="User Image"  [src]="staffForm.value.photo ? staffForm.value.photo : '../../assets/images/user-no.jpg'">
               <img src="../../assets/images/plus-black.png" class="plus-b"></label>
    
    
            <div>
       
       




        <div class="edit-icon">
            <input type="file" id="fileInput3" class="file-input2" (change)="upload('staffCoverLogo',$event)">
            <label for="fileInput3" class="file-label">
            <img src="../../assets/images/edit.png"></label>
        </div>
    
        </div>
        </div>
        
      
    
        <form class="staff-form" [formGroup]="staffForm">
            <div class="row">
                <div class="col-lg-6 col-xs-12 col-sm-6">
            <div class="form-group">
              <label>Name*</label>
              <input type="text" class="form-control"     [(ngModel)]="selectedStaffData.name"  placeholder="Type here" formControlName="name">
            </div>
            </div>
            <div class="col-lg-6 col-xs-12 col-sm-6">
                <div class="form-group">
                  <label>Phone*</label>
                  <input type="text" class="form-control"     [(ngModel)]="selectedStaffData.phoneNumber"  placeholder="Type here"  formControlName="phoneNumber">
                </div>
                </div>
       
    
        <div class="col-lg-6 col-xs-12 col-sm-6 ext-padding">
        <div class="col-lg-12 col-xs-12 col-sm-6">
            <div class="form-group">
              <label>Whatsapp*</label>
              <input type="text" class="form-control"    [(ngModel)]="selectedStaffData.whatsAppNumber"  placeholder="Type here" formControlName="whatsAppNumber">
            </div>
            </div>
            <div class="col-lg-12 col-xs-12 col-sm-6">
                <div class="form-group">
                  <label>Email Id*</label>
                  <input type="text" class="form-control"  [(ngModel)]="selectedStaffData.email"  placeholder="Type here" formControlName="email">
                </div>
                </div>
                </div>
                <div class="col-lg-6 col-xs-12 col-sm-6">
                    <div class="form-group">
                      <label>Address*</label>
                      <textarea class="form-control" placeholder="Type here"  [(ngModel)]="selectedStaffData.address"   style="height: 99px;" formControlName="address"></textarea>
                      <!-- <input type="text" class="form-control" placeholder="Type here"> -->
                    </div>
                    </div>
    
    
                    <div class="col-lg-6 col-xs-12 col-sm-6">
                        <div class="form-group">
                          <label>User name*</label>
                          <input type="text" class="form-control"  [(ngModel)]="selectedStaffData.userName"  placeholder="Type here" formControlName="userName">
                        </div>
                        </div>
                        <div class="col-lg-6 col-xs-12 col-sm-6">
                            <div class="form-group">
                              <label>Password*</label>
                              <input type="password" class="form-control" placeholder="Type here" formControlName="password">
                            </div>
                            </div>
                </div>
          </form>
    
    
    
        <div class="content">
            <button class="add-n" (click)="addStaffFlag=false;agencyDetailsFlag=true;editStaffFlag=false">Back</button>
            <!---->
            <button class="btn-two" (click)="staffCrud('Edit')">Update Staff</button>
        </div>
    
        </div>
    
    

<!-- staff detl -->




  <div class="card2" *ngIf="viewStaffFlag">
                        <p class="table-heading">Agency Details</p>       
                        <div class="agency-head"  [attr.style]="'background-image: url(' + (selectedAgencyDetails.coverImage ? selectedAgencyDetails.coverImage : '../../assets/images/pic1.jpg') + '); background-size: cover;'">
                            <img src="{{selectedAgencyDetails.logo}}">
                            <p>{{selectedAgencyDetails.agencyName}}</p>
                        </div>

                      
                        <p class="table-heading">Staff Details</p>       
                        <div class="agency-head"   [attr.style]="'background-image: url(' + (selectedStaffData.coverImage ? selectedStaffData.coverImage : '../../assets/images/pic1.jpg') + '); background-size: cover;'">
                            <img src="{{selectedStaffData.photo}}">
                            <div>
                            <p>{{this.selectedStaffData.name}}</p>
                            <span>Field executive</span>
                        </div>
                        </div>
                        
                        <table class="agency-table">
                            <tr>
                                <td>
                                    <p class="name-two">Address</p>
                                    <p class="name-one">{{this.selectedStaffData.address}}</p>

                                </td>
                            </tr>
                            <tr>
                                <td>
                                <p class="name-two">Phone number</p>
                                    <p class="name-one">{{this.selectedStaffData.phoneNumber}}</p>
                                    </tr>
                           
                            <tr>
                                <td>
                                    <p class="name-two">Email ID</p>
                                    <p class="name-one">{{this.selectedStaffData.email}}</p>

                                </td>
                            </tr>
                            <tr>
                                <td>
                                <p class="name-two">Contact number</p>
                                    <p class="name-one">{{this.selectedStaffData.whatsAppNumber}}</p>
                                    </tr>
                         
                            <tr>
                                <td>
                                    <p class="name-two">User name</p>
                                    <p class="name-one">{{this.selectedStaffData.userName}}</p>

                                </td>
                            </tr>
                            <tr>
                                <td>
                                <p class="name-two">Password</p>
                                    <p class="name-one">**********</p>
                                    </tr>
                                    <tr>
                                        <td>   
                                    <div class="content">
                                        <button class="add-n" (click)="viewStaffFlag=false;agencyDetailsFlag=true">Back</button>
                                      
                                        <button class="btn-two" (click)="viewStaffFlag=false;editStaffFlag=true;agencyDetailsFlag=false">Edit user</button>
                                    </div>
                                    </td>
                                    </tr>
                            
                         
                        </table>
                     

                        </div>
                    
  <!-- staff end -->


<!-- agency -->


<div class="card2" *ngIf="addAgencyFlag" >
    <p class="table-heading">Agency Details</p>    
    <p class="sub-para">Please fill the details</p>   
    <div class="agency-head" id="agency-h1"  [attr.style]="'background-image: url(' + (agencyForm.value.coverImage ? agencyForm.value.coverImage : '../../assets/images/pic1.jpg') + '); background-size: cover;'">

      <!-- File Input -->
<input type="file" id="fileInput10" (change)="upload('agencyLogo', $event)" />

<!-- Label Styled as Button -->
<label for="fileInput10" class="file-label">
  <!-- Display the Current or Default Image -->
  <img 
    alt="User Image"  
    [src]="agencyForm.value.logo ? agencyForm.value.logo : '../../assets/images/user-no.jpg'"
  >
  <!-- Overlay Plus Icon -->
  <img src="../../assets/images/plus-black.png" class="plus-b">
</label>



         <div>
            <div class="edit-icon">
                <input type="file" id="fileInput5" class="file-input2" (change)="upload('agencyCoverImage',$event)">
                <label for="fileInput5" class="file-label">
                <img src="../../assets/images/edit.png"></label>
            </div>




            <!-- <div class="edit-icon">
                <input type="file" id="fileInput" class="file-input2">
                <label for="fileInput" class="file-label">
                <img src="images/edit.png"></label>
            </div> -->
     </div>
     </div>
     
   

     <form class="staff-form"  [formGroup]="agencyForm">
         <div class="row">
       
     <div class="col-lg-6 col-xs-12 col-sm-6 ext-padding">
     <div class="col-lg-12 col-xs-12 col-sm-6">
         <div class="form-group">
           <label>Agency name*</label>
           <input type="text" class="form-control" placeholder="Type here"  formControlName="agencyName">
         </div>
         </div>
         <div class="col-lg-12 col-xs-12 col-sm-6">
             <div class="form-group upload-div">
               <label>Contract*</label>
                <input type="file" id="fileInput11" class="file-input4" (change)="upload('contract',$event)">
               <label for="fileInput11" class="file-label">
                <img src="../../assets/images/upload-frame.jpg" class="contract-img">
                </label>
                <!-- </div> -->
             </div>
             </div>
             </div>
             <div class="col-lg-6 col-xs-12 col-sm-6">
                 <div class="form-group">
                   <label>Address*</label>
                   <textarea class="form-control" placeholder="Type here" style="height: 202px;" formControlName="address"></textarea>
 
                 </div>
                 </div>


             <!-- </div> -->
             </div>
       <!-- </form> -->

  
    <p class="table-heading">Owner details</p>
    <p class="sub-para">Please fill the details</p>         
    <div class="agency-head" id="agency-h1" [attr.style]="'background-image: url(' + (agencyForm.value.ownerCoverImage ? agencyForm.value.ownerCoverImage : '../../assets/images/pic1.jpg') + '); background-size: cover;'">
       <input type="file" id="fileInput12" class="file-input"  (change)="upload('ownerLogo',$event)">
       <label for="fileInput12" class="file-label">
        <img alt="User Image"  [src]="agencyForm.value.ownerImage ? agencyForm.value.ownerImage : '../../assets/images/user-no.jpg'">
           <img src="../../assets/images/plus-black.png" class="plus-b"></label>


        <div>
   
            <div class="edit-icon">
                <input type="file" id="fileInput6" class="file-input2" (change)="upload('ownerCoverImage',$event)">
                <label for="fileInput6" class="file-label">
                <img src="../../assets/images/edit.png"></label>
            </div>  
            <!-- <div class="edit-icon">
                <input type="file" id="fileInput" class="file-input2">
                <label for="fileInput" class="file-label">
                <img src="images/edit.png"></label>
            </div> -->
        
        </div>
    </div>
    
  

    <!-- <form class="staff-form"> -->
        <div class="row">
            <div class="col-lg-6 col-xs-12 col-sm-6">
        <div class="form-group">
          <label>Name*</label>
          <input type="text" class="form-control" placeholder="Type here" formControlName="owner">
        </div>
        </div>
        <div class="col-lg-6 col-xs-12 col-sm-6">
            <div class="form-group">
              <label>Contact number*</label>
              <input type="text" class="form-control" placeholder="Type here" formControlName="contactNumber">
            </div>
            </div>
   

          

                <div class="col-lg-12 col-xs-12 col-sm-6">
                    <div class="form-group">
                      <label>Email ID*</label>
                      <input type="email" class="form-control" placeholder="Type here" formControlName="email">
                    </div>
                    </div>
              
            </div>
      </form>



    <div class="content" >
        <button class="add-n" (click)="addAgencyFlag=false;agencyDetailsFlag=true">Cancel</button>
        <!---->
        <button class="btn-two" (click)="agencyCrud('Add')">Create Agency</button>
    </div>

    </div>






    
<div class="card2" *ngIf="editAgencyFlag"  >
    <p class="table-heading">Agency Details</p>    
    <p class="sub-para">Please fill the details</p>   
    <div class="agency-head" id="agency-h1"  [attr.style]="'background-image: url(' + (agencyForm.value.coverImage ? agencyForm.value.coverImage : '../../assets/images/pic1.jpg') + '); background-size: cover;'">

        <input type="file" id="fileInput10" class="file-input" (change)="upload('agencyLogo',$event)">
        <label for="fileInput10" class="file-label">
         <img alt="User Image"  [src]="agencyForm.value.logo ? agencyForm.value.logo : '../../assets/images/user-no.jpg'">
            <img src="../../assets/images/plus-black.png" class="plus-b"></label>


         <div>
            <div class="edit-icon">
                <input type="file" id="fileInput5" class="file-input2" (change)="upload('agencyCoverImage',$event)">
                <label for="fileInput5" class="file-label">
                <img src="../../assets/images/edit.png"></label>
            </div>




            <!-- <div class="edit-icon">
                <input type="file" id="fileInput" class="file-input2">
                <label for="fileInput" class="file-label">
                <img src="images/edit.png"></label>
            </div> -->
     </div>
     </div>
     
   

     <form class="staff-form"  [formGroup]="agencyForm">
         <div class="row">
       
     <div class="col-lg-6 col-xs-12 col-sm-6 ext-padding">
     <div class="col-lg-12 col-xs-12 col-sm-6">
         <div class="form-group">
           <label>Agency name*</label>
           <input type="text" class="form-control" placeholder="Type here"   [(ngModel)]="selectedAgencyDetails.agencyName" formControlName="agencyName">
         </div>
         </div>
         <div class="col-lg-12 col-xs-12 col-sm-6">
             <div class="form-group upload-div">
               <label>Contract*</label>
                <input type="file" id="fileInput11" class="file-input4" (change)="upload('contract',$event)">
               <label for="fileInput11" class="file-label">
                <img src="../../assets/images/upload-frame.jpg" class="contract-img">
                </label>
                <!-- </div> -->
             </div>
             </div>
             </div>
             <div class="col-lg-6 col-xs-12 col-sm-6">
                 <div class="form-group">
                   <label>Address*</label>
                   <textarea class="form-control" placeholder="Type here" style="height: 202px;"  [(ngModel)]="selectedAgencyDetails.address"  formControlName="address"></textarea>
 
                 </div>
                 </div>


             <!-- </div> -->
             </div>
       <!-- </form> -->

  
    <p class="table-heading">Owner details</p>
    <p class="sub-para">Please fill the details</p>         
    <div class="agency-head" id="agency-h1" [attr.style]="'background-image: url(' + (agencyForm.value.ownerCoverImage ? agencyForm.value.ownerCoverImage : '../../assets/images/pic1.jpg') + '); background-size: cover;'">
       <input type="file" id="fileInput12" class="file-input"  (change)="upload('ownerLogo',$event)">
       <label for="fileInput12" class="file-label">
        <img alt="User Image"  [src]="agencyForm.value.ownerImage ? agencyForm.value.ownerImage : '../../assets/images/user-no.jpg'">
           <img src="../../assets/images/plus-black.png" class="plus-b"></label>


        <div>
   
            <div class="edit-icon">
                <input type="file" id="fileInput6" class="file-input2" (change)="upload('ownerCoverImage',$event)">
                <label for="fileInput6" class="file-label">
                <img src="../../assets/images/edit.png"></label>
            </div>  
            <!-- <div class="edit-icon">
                <input type="file" id="fileInput" class="file-input2">
                <label for="fileInput" class="file-label">
                <img src="images/edit.png"></label>
            </div> -->
        
        </div>
    </div>
    
  

    <!-- <form class="staff-form"> -->
        <div class="row">
            <div class="col-lg-6 col-xs-12 col-sm-6">
        <div class="form-group">
          <label>Name*</label>
          <input type="text" class="form-control" placeholder="Type here"  [(ngModel)]="selectedAgencyDetails.owner" formControlName="owner">
        </div>
        </div>
        <div class="col-lg-6 col-xs-12 col-sm-6">
            <div class="form-group">
              <label>Contact number*</label>
              <input type="text" class="form-control" placeholder="Type here"   [(ngModel)]="selectedAgencyDetails.contactNumber"  formControlName="contactNumber">
            </div>
            </div>
   

          

                <div class="col-lg-12 col-xs-12 col-sm-6">
                    <div class="form-group">
                      <label>Email ID*</label>
                      <input type="email" class="form-control" placeholder="Type here"   [(ngModel)]="selectedAgencyDetails.email" formControlName="email">
                    </div>
                    </div>
              
            </div>
      </form>



    <div class="content" >
        <button class="add-n" (click)="editAgencyFlag=false;agencyDetailsFlag=true">Cancel</button>
        <!---->
        <button class="btn-two" (click)="agencyCrud('Edit')">Update Agency</button>
    </div>

    </div>

























































                        <div id="popup1" class="overlay1" *ngIf="popUp">
                            <div class="popup-img">{{image}}
                              <a class="close-img"  (click)="popUp=false">&times;</a>
                              <img src="{{image}}" *ngIf="isImage(image)" />
                          
                              <!-- <ng2-pdfjs-viewer *ngIf="isPDF(image)" pdfSrc="{{image}}">
                                <a class="close" (click)="popUp=false">&times;</a>
                              </ng2-pdfjs-viewer> -->
                            </div>
                          </div>


 <!--  -->

       </div>                 
                 
                    </div>
                   
            </div>

    
            </main>
   
    </div>
    </div>











 <!--Popup start-->

 <!-- <div id="add-enquiry" class="overlay">
    <div class="popup-ins" id="popup-ins1">
        <div class="ins-f" id="ins-f1">
        <h2>Confirmation</h2>
            <p class="table-h1">Are you sure you want to disable “ABC Technologies” ? </p>
    </div>
        <div class="ins-footer">
    <button class="btn-sec">Cancel</button>
    <button class="btn-prime">Yes</button>
    </div>
  
    </div>
  </div>
   -->
   
   <!--Popup end-->


</body>